import { createAction, props } from '@ngrx/store';
import { LoginCredentials, SignupCredentials } from 'src/app/public/account/models/auth-credentials.model';

export class AuthActions {

    public static initAuthForm = createAction(
        '[Auth Form] Init Auth Form'
    );

    public static loginSubmit = createAction(
        '[AuthForm Component] Login Form Submit',
        props <{ loginCredentials: LoginCredentials }> ()
    );

    public static signupSubmit = createAction(
        '[AuthForm Component] Signup Form Submit',
        props <{ signupCredentials: SignupCredentials }> ()
    );

    public static recoverPasswordSubmit = createAction(
        '[AuthForm Component] Password Recover Submit',
        props <{ username: string }> ()
    );

    public static updatePasswordSubmit = createAction(
        '[AuthForm Component] Password Update Submit',
        props <{ oldPassword: string, newPassword: string }> ()
    );

    public static loginResult = createAction(
        '[Auth API] Login Result',
        props <{ message: string }> ()
    );

    public static signupResult = createAction(
        '[Auth API] Signup Result',
        props <{ message: string }> ()
    );

    public static authSuccess = createAction(
        '[Auth Component] Auth Success',
        props <{ token?: string, userId?: string,  }> ()
    );

    public static authResult = createAction(
        '[Auth Component] Auth Result',
        props <{ loggedIn: boolean, token?: string, userId?: string, message?: string }> ()
    );

    public static recoverPasswordResult = createAction(
        '[Auth API] Password Recover Result',
        props <{ message: string }> ()
    );

    public static updatePasswordResult = createAction(
        '[Auth API] Password Update Result',
        props <{ message: string }> ()
    );

    public static logoutSubmit = createAction(
        '[AuthForm Component] Logout Form Submit' 
    );
}
